export default "__VITE_ASSET__fe992ffc__";